
import { ColumnDef } from '@/pages/search/results/table/table-layout';
import Vue from 'vue';
import SelectPicker from '@/components/SelectPicker.vue';
export default Vue.component('TableHeader', {
	components: { SelectPicker },
	props: {
		disabled: Boolean,
		col: Object as () => ColumnDef,
		sort: String
	},
	methods: {
		changeSort(sort: string) { this.$emit('changeSort', sort); }
	}
})
